<template>
  <div>
    <HeaderSmallPrimary>
      PASSWORD
    </HeaderSmallPrimary>
    <template v-if="isSsoUser">
      <TextAnnotationPrimary>
        You can't set password since your email domain is configured for Single Sign On.
      </TextAnnotationPrimary>
    </template>
    <template v-else>
      <validation-observer v-slot="{ invalid }"
                           :style="validationObserverStyle">
        <template v-if="showForms">
          <FormPasswordPrimary passwordLabel="Current Password"
                               passwordPlaceholder="Enter current password"
                               v-model="currentPassword"
                               :disablePasswordConfirmation="true"
                               :disableStrongPassword="true"
                               :style="formStyle" />
          <FormPasswordPrimary anotherPasswordLabel="Confirm New Password"
                               anotherPasswordPlaceholder="Re-enter new password"
                               passwordLabel="New Password"
                               passwordPlaceholder="Enter new password"
                               v-model="newPassword"
                               :disablePasswordConfirmation="false"
                               :style="formStyle"/>
        </template>
        <div :style="buttonsContainerStyle">
          <template v-if="showForms">
            <ButtonSecondary minWidth="80px"
                             @click="cancel">
              Cancel
            </ButtonSecondary>
            <ButtonPrimary minWidth="122px"
                           :disabled="invalid"
                           :style="buttonStyle"
                           @click="updatePassword">
              Save Change
            </ButtonPrimary>
          </template>
          <template v-else>
            <ButtonSecondary minWidth="86px"
                             @click="showPasswordForms">
              Change
            </ButtonSecondary>
          </template>
        </div>
      </validation-observer>
    </template>
  </div>
</template>

<script>
  import ApiCurrentUserPassword from '@js/api/current-user-password'
  import ButtonPrimary from '@modules/button/button-primary'
  import ButtonSecondary from '@modules/button/button-secondary'
  import FormPasswordPrimary from '@modules/form/form-password-primary'
  import HeaderSmallPrimary from '@modules/text/header-small-primary'
  import TextAnnotationPrimary from '@modules/text/text-annotation-primary'
  import { Layout } from '@js/styles'
  import { ValidationObserver } from 'vee-validate'

  export default {
    name: 'UserPasswordForm',
    components: {
      ButtonPrimary,
      ButtonSecondary,
      FormPasswordPrimary,
      HeaderSmallPrimary,
      TextAnnotationPrimary,
      ValidationObserver,
    },
    props: {
      isSsoUser: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        buttonsContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: Layout.space.lg,
        },
        buttonStyle: {
          marginLeft: Layout.space.md,
        },
        currentPassword: '',
        formStyle: {
          margin: `${Layout.space.lg} 0 0 0`,
        },
        inputAttrs: {
          inputType: 'password',
        },
        inputStyle: {
          marginTop: Layout.space.lg,
        },
        newPassword: '',
        showForms: false,
        validationObserverStyle: {
          width: '100%',
        },
      };
    },
    methods: {
      cancel: function () {
        this.clearForms();
        this.showForms = false;
      },
      clearForms: function () {
        this.confirmPassword = '';
        this.currentPassword = '';
        this.newPassword = '';
      },
      showPasswordForms: function () {
        this.showForms = true;
      },
      updatePassword: async function () {
        try {
          const payload = await {
            password: this.currentPassword,
            newPassword: this.newPassword,
          };
          const api = await new ApiCurrentUserPassword();
          const res = await api.post(payload);
          //await this.$store.dispatch('user/updatePassword', payload);
          this.showForms = await false;
          await this.clearForms();
          await this.$store.commit('notification/setMessage', 'Updated password');
        } catch (error) {
          console.error(error);
          this.$store.commit('notification/setWarning', 'Failed to update password');
        }
      },
    },
  };
</script>
